import { render, staticRenderFns } from "./BinarySummaryTK.vue?vue&type=template&id=afe872f4&scoped=true"
import script from "./BinarySummaryTK.vue?vue&type=script&lang=js"
export * from "./BinarySummaryTK.vue?vue&type=script&lang=js"
import style0 from "./BinarySummaryTK.vue?vue&type=style&index=0&id=afe872f4&prod&lang=css&scoped=true"
import style1 from "./BinarySummaryTK.vue?vue&type=style&index=1&id=afe872f4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe872f4",
  null
  
)

export default component.exports